import React, { useState } from 'react';
import { WordCard, NavigationButtons, BackgroundWrapper, ImportantButton, FlipIcon } from 'components';
import './HelpCardsSection.css';

const DEMO_CARDS = [
  { word: 'das Wort', definition: 'the word' },
  { word: 'die Einheit', definition: 'the unit' },
  { word: 'der Buchstabe', definition: 'the letter' },
];

const Flip = () => <span className="help-icon-inline"><FlipIcon /></span>;

const HelpCardsSection = ({ onFinish }) => {
  const [cardIndex, setCardIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [hasBeenFlipped, setHasBeenFlipped] = useState(false);

  const advance = () => {
    const next = cardIndex + 1;
    if (next >= DEMO_CARDS.length) {
      onFinish();
    } else {
      setCardIndex(next);
      setFlipped(false);
      setHasBeenFlipped(false);
    }
  };

  const hint = () => {
    if (!flipped) {
      return (
        <>
          <p className="help-hint">
            A word appears on the card. If you already know it, click <strong>✓</strong> to move on.
          </p>
          <p className="help-hint">
            Not sure? Click <Flip /> to reveal the definition.
          </p>
        </>
      );
    }
    return (
      <p className="help-hint">
        Here's the definition. Click <strong>X</strong> to move to the next card.
      </p>
    );
  };

  return (
    <BackgroundWrapper>
      <WordCard word={flipped ? DEMO_CARDS[cardIndex].definition : DEMO_CARDS[cardIndex].word} />
      <ImportantButton
        onClick={() => {
          setFlipped((prev) => !prev);
          setHasBeenFlipped(true);
        }}
      >
        <FlipIcon />
      </ImportantButton>
      <NavigationButtons
        callbackLeft={advance}
        callbackRight={advance}
        rightDisabled={hasBeenFlipped}
      />
      <p className="help-progress">Card {cardIndex + 1} of {DEMO_CARDS.length}</p>
      <div className="help-hint-area">{hint()}</div>
    </BackgroundWrapper>
  );
};

export { HelpCardsSection };
